module.exports = __webpack_public_path__ + "img/appstore.d8f00cf8.webp";